import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, Gauge, Fuel, Settings } from 'lucide-react';
interface Vehicle {
  id: number;
  name: string;
  model: string;
  price: string;
  image: string;
  year: string;
  mileage: string;
  condition: 'New' | 'Used';
  transmission: string;
  fuelType: string;
}
const vehicles: Vehicle[] = [{
  id: 1,
  name: 'Rolls-Royce',
  model: 'Phantom',
  price: '$485,000',
  year: '2024',
  mileage: '1,200 km',
  condition: 'New',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1631295868223-63265b40d9e4?q=80&w=800&auto=format&fit=crop'
}, {
  id: 2,
  name: 'Bentley',
  model: 'Continental GT',
  price: '$245,000',
  year: '2024',
  mileage: '850 km',
  condition: 'New',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1621135802920-133df287f89c?q=80&w=800&auto=format&fit=crop'
}, {
  id: 3,
  name: 'Ferrari',
  model: '812 Superfast',
  price: '$365,000',
  year: '2024',
  mileage: '2,100 km',
  condition: 'New',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1583121274602-3e2820c69888?q=80&w=800&auto=format&fit=crop'
}, {
  id: 4,
  name: 'Lamborghini',
  model: 'Aventador',
  price: '$425,000',
  year: '2023',
  mileage: '8,500 km',
  condition: 'Used',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1544636331-e26879cd4d9b?q=80&w=800&auto=format&fit=crop'
}, {
  id: 5,
  name: 'Aston Martin',
  model: 'DB12',
  price: '$245,000',
  year: '2024',
  mileage: '500 km',
  condition: 'New',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1610768764270-790fbec18178?q=80&w=800&auto=format&fit=crop'
}, {
  id: 6,
  name: 'Porsche',
  model: '911 Turbo S',
  price: '$225,000',
  year: '2023',
  mileage: '12,400 km',
  condition: 'Used',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=800&auto=format&fit=crop'
}, {
  id: 7,
  name: 'Mercedes-Benz',
  model: 'S-Class S 500',
  price: '$125,000',
  year: '2024',
  mileage: '3,200 km',
  condition: 'New',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?q=80&w=800&auto=format&fit=crop'
}, {
  id: 8,
  name: 'BMW',
  model: 'M5 Competition',
  price: '$115,000',
  year: '2024',
  mileage: '1,800 km',
  condition: 'New',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?q=80&w=800&auto=format&fit=crop'
}, {
  id: 9,
  name: 'Audi',
  model: 'RS7 Sportback',
  price: '$135,000',
  year: '2023',
  mileage: '15,600 km',
  condition: 'Used',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?q=80&w=800&auto=format&fit=crop'
}, {
  id: 10,
  name: 'Lexus',
  model: 'LC 500',
  price: '$95,000',
  year: '2024',
  mileage: '2,400 km',
  condition: 'New',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1627454820516-d0f0d3a5fd5f?q=80&w=800&auto=format&fit=crop'
}, {
  id: 11,
  name: 'Hyundai',
  model: 'Genesis G90',
  price: '$88,000',
  year: '2024',
  mileage: '1,100 km',
  condition: 'New',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1617531653332-bd46c24f2068?q=80&w=800&auto=format&fit=crop'
}, {
  id: 12,
  name: 'Kia',
  model: 'Stinger GT',
  price: '$52,000',
  year: '2023',
  mileage: '18,900 km',
  condition: 'Used',
  transmission: 'Automatic',
  fuelType: 'Petrol',
  image: 'https://images.unsplash.com/photo-1619767886558-efdc259cde1a?q=80&w=800&auto=format&fit=crop'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 40
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function FeaturedVehicles() {
  return <section className="w-full bg-[var(--color-black-rich)] py-24 px-6" data-id="element-108">
      <div className="max-w-7xl mx-auto" data-id="element-109">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-110">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4" data-id="element-111">
            Curated Collection
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto font-light" data-id="element-112">
            Each vehicle in our collection represents the pinnacle of automotive
            engineering and design
          </p>
        </motion.div>

        {/* Vehicle Grid */}
        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-113">
          {vehicles.map(vehicle => <motion.article key={vehicle.id} variants={item} whileHover={{
          scale: 1.02
        }} className="group bg-[var(--color-black-soft)] overflow-hidden cursor-pointer transition-all duration-500 hover:shadow-[0_0_40px_rgba(212,175,55,0.15)]" data-id="element-114">
              {/* Image */}
              <div className="relative h-64 overflow-hidden" data-id="element-115">
                <img src={vehicle.image} alt={`${vehicle.year} ${vehicle.name} ${vehicle.model}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-116" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-117" />
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-118">
                <div className="mb-4" data-id="element-119">
                  <div className="flex items-center gap-2 mb-2" data-id="element-120">
                    <p className="text-[var(--color-gold)] text-sm font-medium" data-id="element-121">
                      {vehicle.year}
                    </p>
                    <span className="text-gray-600" data-id="element-122">•</span>
                    <span className={`text-xs font-medium px-2 py-1 rounded ${vehicle.condition === 'New' ? 'bg-emerald-500/10 text-emerald-400' : 'bg-blue-500/10 text-blue-400'}`} data-id="element-123">
                      {vehicle.condition}
                    </span>
                  </div>
                  <h3 className="text-2xl font-semibold text-white mb-1" data-id="element-124">
                    {vehicle.name}
                  </h3>
                  <p className="text-gray-400 text-lg" data-id="element-125">{vehicle.model}</p>
                </div>

                {/* Vehicle Details */}
                <div className="grid grid-cols-3 gap-3 mb-4 pb-4 border-b border-gray-800" data-id="element-126">
                  <div className="flex flex-col items-center text-center" data-id="element-127">
                    <Gauge className="w-4 h-4 text-[var(--color-gold)] mb-1" aria-hidden="true" data-id="element-128" />
                    <span className="text-xs text-gray-500" data-id="element-129">Mileage</span>
                    <span className="text-sm text-white font-medium" data-id="element-130">
                      {vehicle.mileage}
                    </span>
                  </div>
                  <div className="flex flex-col items-center text-center" data-id="element-131">
                    <Settings className="w-4 h-4 text-[var(--color-gold)] mb-1" aria-hidden="true" data-id="element-132" />
                    <span className="text-xs text-gray-500" data-id="element-133">Transmission</span>
                    <span className="text-sm text-white font-medium" data-id="element-134">
                      {vehicle.transmission}
                    </span>
                  </div>
                  <div className="flex flex-col items-center text-center" data-id="element-135">
                    <Fuel className="w-4 h-4 text-[var(--color-gold)] mb-1" aria-hidden="true" data-id="element-136" />
                    <span className="text-xs text-gray-500" data-id="element-137">Fuel</span>
                    <span className="text-sm text-white font-medium" data-id="element-138">
                      {vehicle.fuelType}
                    </span>
                  </div>
                </div>

                <div className="flex items-center justify-between" data-id="element-139">
                  <p className="text-2xl font-bold text-white" data-id="element-140">
                    {vehicle.price}
                  </p>
                  <button className="inline-flex items-center gap-2 text-[var(--color-gold)] font-medium group-hover:gap-3 transition-all" aria-label={`View details for ${vehicle.name} ${vehicle.model}`} data-id="element-141">
                    View Details
                    <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-142" />
                  </button>
                </div>
              </div>
            </motion.article>)}
        </motion.div>
      </div>
    </section>;
}